module.exports = __webpack_public_path__ + "img/007-serving-dish.92edf9ea.svg";